(function(){
  'use strict';
  var version='2026-08-04-v2';
  if(window.__vitaCoreProductPageVersion===version)return;
  window.__vitaCoreProductPageVersion=version;

  function normalise(value){return String(value==null?'':value).trim().toLowerCase()}
  function parseQuantity(value,fallback){
    var match=String(value||'').match(/(\d+(?:[.,]\d+)?)/);
    if(!match)return fallback||1;
    var number=Number(match[1].replace(',','.'));
    return Number.isFinite(number)&&number>0?number:(fallback||1)
  }
  function formatMoney(cents,currency){
    var amount=Number(cents||0)/100;
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en-MT',{
        style:'currency',currency:currency||'EUR',minimumFractionDigits:amount%1===0?0:2,maximumFractionDigits:2
      }).format(amount)
    }catch(error){return (currency||'EUR')+' '+amount.toFixed(2)}
  }
  function readVariants(picker){
    var script=picker.querySelector('[data-vc-product-variants]');
    if(!script)return[];
    try{return JSON.parse(script.textContent||'[]')}catch(error){return[]}
  }
  function selectedOptions(picker){
    var selected={};
    picker.querySelectorAll('[data-vc-option-position]').forEach(function(group){
      var position=Number(group.getAttribute('data-vc-option-position'));
      var checked=group.querySelector('input[type="radio"]:checked');
      var select=group.querySelector('select');
      if(checked)selected[position]=checked.value;
      else if(select)selected[position]=select.value
    });
    return selected
  }
  function findVariant(variants,position,value,selected){
    var exact=variants.find(function(variant){
      if(!variant||!Array.isArray(variant.options))return false;
      if(normalise(variant.options[position-1])!==normalise(value))return false;
      return variant.options.every(function(optionValue,index){
        var optionPosition=index+1;
        if(optionPosition===position||!selected[optionPosition])return true;
        return normalise(optionValue)===normalise(selected[optionPosition])
      })
    });
    if(exact)return exact;
    return variants.find(function(variant){
      return variant&&Array.isArray(variant.options)&&normalise(variant.options[position-1])===normalise(value)
    })||null
  }
  function setText(element,text){
    if(!element)return;
    element.textContent=text||'';
    element.hidden=!text
  }
  function renderOfferGroup(picker,fieldset,variants){
    var currency=picker.getAttribute('data-currency-code')||'EUR';
    var position=Number(fieldset.getAttribute('data-vc-option-position'));
    var selected=selectedOptions(picker);
    var inputs=Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    if(!position||!inputs.length||!variants.length)return;

    var entries=inputs.map(function(input,index){
      var variant=findVariant(variants,position,input.value,selected);
      return{
        input:input,
        label:fieldset.querySelector('label[for="'+input.id+'"]'),
        quantity:parseQuantity(input.value,index+1),
        variant:variant,
        price:variant?Number(variant.price||0):0,
        compareAt:variant?Number(variant.compare_at_price||0):0
      }
    }).filter(function(entry){return entry.label&&entry.price>0});
    if(!entries.length)return;

    entries.sort(function(a,b){return a.quantity-b.quantity});
    var baseEntry=entries[0];
    var baseUnit=baseEntry.price/Math.max(baseEntry.quantity,1);

    entries.forEach(function(entry,index){
      var regularFromBase=baseUnit*entry.quantity;
      var regularTotal=Math.max(entry.price,entry.compareAt,regularFromBase);
      var saving=Math.max(0,regularTotal-entry.price);
      var savingPercent=regularTotal>entry.price?Math.round((saving/regularTotal)*100):0;
      var unitPrice=entry.price/Math.max(entry.quantity,1);
      var regularUnit=regularTotal/Math.max(entry.quantity,1);
      var badge=entry.label.querySelector('[data-vc-offer-badge]');
      var sub=entry.label.querySelector('[data-vc-offer-sub]');
      var price=entry.label.querySelector('[data-vc-offer-price]');
      var ribbon=entry.label.querySelector('[data-vc-offer-ribbon]');

      setText(badge,savingPercent>0?'SAVE '+savingPercent+'%':'');
      setText(sub,saving>0?'SAVE '+formatMoney(saving,currency):'STANDARD PRICE');

      if(price){
        var mainPrice=entry.quantity>1?formatMoney(unitPrice,currency)+' EACH':formatMoney(entry.price,currency);
        var oldPrice=saving>0?'<s>'+formatMoney(entry.quantity>1?regularUnit:regularTotal,currency)+'</s>':'';
        price.innerHTML='<strong>'+mainPrice+'</strong>'+oldPrice;
        price.hidden=false
      }

      var ribbonText='';
      if(entries.length>=3&&index===1)ribbonText='MOST POPULAR';
      if(index===entries.length-1&&entry.quantity>baseEntry.quantity)ribbonText='BEST VALUE';
      if(entries.length===2&&index===1)ribbonText='BEST VALUE';
      setText(ribbon,ribbonText);
      entry.label.classList.toggle('vc-has-ribbon',Boolean(ribbonText))
    })
  }
  function renderPicker(picker){
    var variants=readVariants(picker);
    picker.querySelectorAll('.vc-option--offer').forEach(function(fieldset){renderOfferGroup(picker,fieldset,variants)})
  }
  function dedupePickers(){
    var seen={};
    document.querySelectorAll('.product__info-container variant-selects[data-vc-product-picker]').forEach(function(picker){
      var key=(picker.getAttribute('data-product-id')||'')+'|'+(picker.getAttribute('data-section')||'');
      if(seen[key]){
        picker.setAttribute('data-vc-duplicate','true');
        picker.hidden=true
      }else{
        seen[key]=true;
        picker.removeAttribute('data-vc-duplicate');
        picker.hidden=false
      }
    })
  }
  function cleanProductLayout(){
    document.querySelectorAll('.product__info-container').forEach(function(container){
      var hasOffer=Boolean(container.querySelector('.vc-option--offer'));
      var quantity=container.querySelector('.product-form__quantity');
      if(quantity){
        if(hasOffer){
          quantity.hidden=true;
          quantity.style.setProperty('display','none','important')
        }else{
          quantity.hidden=false;
          quantity.style.removeProperty('display')
        }
      }
      container.querySelectorAll('.product__text').forEach(function(textBlock){
        if(normalise(textBlock.textContent).indexOf('daily wellness care')!==-1){
          textBlock.hidden=true;
          textBlock.style.setProperty('display','none','important')
        }
      })
    })
  }
  function initialisePicker(picker){
    if(!picker||picker.dataset.vcInitialised==='true')return;
    picker.dataset.vcInitialised='true';
    renderPicker(picker);
    picker.addEventListener('change',function(){window.requestAnimationFrame(function(){renderPicker(picker);cleanProductLayout()})})
  }
  function install(){
    dedupePickers();
    document.querySelectorAll('variant-selects[data-vc-product-picker]:not([data-vc-duplicate="true"])').forEach(initialisePicker);
    cleanProductLayout()
  }

  document.addEventListener('variant:change',install);
  document.addEventListener('product:variant-change',install);
  document.addEventListener('shopify:section:load',install);
  document.addEventListener('shopify:block:select',install);
  document.addEventListener('DOMContentLoaded',install,{once:true});
  install();
  new MutationObserver(function(){window.requestAnimationFrame(install)}).observe(document.documentElement,{childList:true,subtree:true})
})();
